import page from '@/components/page'
import panelMain from '@/components/panel-main'
import pagination from '@/components/pagination'

const components = [
  page,
  panelMain,
  pagination
]

function install(Vue) {
  components.forEach(component => {
    Vue.component(component.name, component)
  })
}

export default { install }
